module.exports = __webpack_public_path__ + "a8750c743f1e1aaef5256321987f02ce.png";